

















import { Component, Vue } from 'vue-property-decorator';
@Component
export default class CalendarViewSwitch extends Vue {
  public tab = 'week';
  private switchView(tab = 'week') {
    this.tab = tab;
    this.$emit('switchView', {
      year: new Date().getFullYear(),
      tab,
    });
  }
}
